/* ═══════════════════════════════════════════════
   LES NOBLES ESSENCES — Shopify AJAX Cart
   ═══════════════════════════════════════════════ */

(function () {

  /* ── State ────────────────────────────────────── */
  var drawerOverlay = null;
  var drawer = null;
  var drawerBody = null;
  var cartCountEl = null;

  /* ── Init ─────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    drawerOverlay = document.getElementById('cartDrawerOverlay');
    drawer = document.getElementById('cartDrawer');
    drawerBody = document.getElementById('cartDrawerBody');
    cartCountEl = document.getElementById('cartCount');

    // Close drawer
    var closeBtn = document.getElementById('cartDrawerClose');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

    // View cart link
    var viewCartBtn = document.getElementById('cartDrawerViewCart');
    if (viewCartBtn) {
      viewCartBtn.addEventListener('click', function () {
        window.location.href = '/cart';
      });
    }

    // Checkout button
    var checkoutBtn = document.getElementById('cartDrawerCheckout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        window.location.href = '/checkout';
      });
    }

    // Add to cart buttons
    bindAddToCartButtons();

    // Update cart count on load
    updateCartCount();
  });

  /* ── Bind all add-to-cart buttons ─────────────── */
  function bindAddToCartButtons() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var quantity = parseInt(btn.dataset.quantity || '1', 10);
        if (!variantId) return;
        addToCart(variantId, quantity, btn);
      });
    });
  }

  /* ── Add to Cart ───────────────────────────────── */
  function addToCart(variantId, quantity, triggerBtn) {
    if (triggerBtn) {
      triggerBtn.disabled = true;
      triggerBtn.textContent = 'Ajout en cours…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (item) {
      if (item.status) {
        // Error from Shopify
        console.error('Cart add error:', item.description);
        if (triggerBtn) {
          triggerBtn.disabled = false;
          triggerBtn.innerHTML = triggerBtn.dataset.originalText || 'Ajouter au panier';
        }
        return;
      }
      if (triggerBtn) {
        triggerBtn.disabled = false;
        triggerBtn.innerHTML = triggerBtn.dataset.originalText || 'Ajouter au panier';
      }
      refreshCart();
      openDrawer();
    })
    .catch(function (err) {
      console.error('Cart error:', err);
      if (triggerBtn) {
        triggerBtn.disabled = false;
        triggerBtn.innerHTML = triggerBtn.dataset.originalText || 'Ajouter au panier';
      }
    });
  }

  /* ── Refresh cart ──────────────────────────────── */
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      renderDrawerItems(cart);
    })
    .catch(function (err) { console.error('Cart fetch error:', err); });
  }

  /* ── Update cart count badge ───────────────────── */
  function updateCartCount(count) {
    if (count === undefined) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { setCount(cart.item_count); });
    } else {
      setCount(count);
    }
  }

  function setCount(count) {
    if (cartCountEl) cartCountEl.textContent = '(' + count + ')';
    var badge = document.getElementById('cartDrawerBadge');
    if (badge) badge.textContent = count;
  }

  /* ── Render drawer items ───────────────────────── */
  function renderDrawerItems(cart) {
    if (!drawerBody) return;

    var totalEl = document.getElementById('cartDrawerTotal');
    var footerEl = document.getElementById('cartDrawerFooter');

    if (cart.item_count === 0) {
      drawerBody.innerHTML = '<div class="cart-drawer-empty"><p>Votre panier est vide.</p><a href="/collections/tous-les-parfums" class="btn-outline-dark" style="display:inline-flex;">Découvrir nos parfums</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
      var decIcon = item.quantity === 1
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="13" height="13"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
      var incIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

      html += '<div class="cart-drawer-item" data-key="' + item.key + '">' +
        (imgSrc ? '<a href="' + item.url + '"><img class="cart-drawer-item-img" src="' + imgSrc + '" alt="' + item.product_title + '" /></a>' : '<div class="cart-drawer-item-img"></div>') +
        '<div class="cart-drawer-item-info">' +
          '<div class="cart-drawer-item-name">' + item.product_title + '</div>' +
          '<div class="cart-drawer-item-variant">LNE · Extrait de Parfum</div>' +
          '<div class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="cart-drawer-item-row">' +
            '<div class="cart-drawer-item-qty">' +
              '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">' + decIcon + '</button>' +
              '<span class="qty-val">' + item.quantity + '</span>' +
              '<button class="qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">' + incIcon + '</button>' +
            '</div>' +
            '<button class="cart-item-remove" data-action="remove" data-key="' + item.key + '">Retirer</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    });

    drawerBody.innerHTML = html;

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // Bind qty buttons
    drawerBody.querySelectorAll('.qty-btn, .cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qty = btn.dataset.action === 'remove' ? 0 : parseInt(btn.dataset.qty, 10);
        changeCartItem(key, qty);
      });
    });
  }

  /* ── Change item quantity ──────────────────────── */
  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      renderDrawerItems(cart);
    })
    .catch(function (err) { console.error('Cart change error:', err); });
  }

  /* ── Open / close drawer ───────────────────────── */
  function openDrawer() {
    if (drawer) {
      drawer.classList.add('open');
      drawer.style.transform = 'translateX(0)';
      drawer.style.visibility = 'visible';
      drawer.style.zIndex = '9999';
    }
    if (drawerOverlay) {
      drawerOverlay.classList.add('open');
      drawerOverlay.style.opacity = '1';
      drawerOverlay.style.pointerEvents = 'all';
      drawerOverlay.style.zIndex = '9998';
    }
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove('open');
      drawer.style.transform = '';
      drawer.style.visibility = '';
      drawer.style.zIndex = '';
    }
    if (drawerOverlay) {
      drawerOverlay.classList.remove('open');
      drawerOverlay.style.opacity = '';
      drawerOverlay.style.pointerEvents = '';
      drawerOverlay.style.zIndex = '';
    }
    document.body.style.overflow = '';
  }

  /* ── Format money (cents → €) ──────────────────── */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ── Expose openDrawer globally ────────────────── */
  window.LNECart = { open: openDrawer, refresh: refreshCart, addToCart: addToCart };

})();
